// ** Auth Endpoints
//
// NOTE: only the storage key names below are actually used by the app. Login goes straight to
// `${imgUrl}/token/generate-token` in views/Login.js, and refresh/logout are handled by
// shared/authentication/authSession.js. The endpoints here are the real backend routes rather than
// the template's `/jwt/*` placeholders, which pointed at routes that do not exist — anyone wiring
// JwtService up in future would otherwise have silently got 404s instead of a working refresh.
export default {
  loginEndpoint: '/token/generate-token',
  registerEndpoint: '/user/signup',
  refreshEndpoint: '/token/refresh',
  logoutEndpoint: '/token/logout',

  // ** This will be prefixed in authorization header with token
  // ? e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // ** Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken'
}
